// extracted by mini-css-extract-plugin
module.exports = {"footer":"MakeOfferModal_footer__3tXFM","label":"MakeOfferModal_label__QIQ8n","glms-usd-conversion-text":"MakeOfferModal_glms-usd-conversion-text__3_9f0"};